const cardNumberValidation = value => {
  if (!value) {
    return null
  }

  if (
    !['4', '5', '8'].some(digit => {
      return value[0] === digit
    })
  ) {
    return 'Invalid card number'
  }

  if (value.length < 19) {
    return 'Enter your 16-digit Link Rewards card number.'
  }

  return null
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'ONCHANGE_PLUS_CARD_NUMBER': {
      return {
        ...state,
        plusCardNumber: action.value,
        cardInputHelpText: cardNumberValidation(action.value),
      }
    }
    case 'VERIFY_CARD_NUMBER': {
      if (state.plusCardNumber.length < 19) {
        return state
      }

      return {
        ...state,
        currentState: 'verifyCardNumber',
        plusCardNumber: state.plusCardNumber.replace(/\s+/g, ''),
      };
    }
    case 'VERIFICATION_ERROR':
      return {
        ...state,
        currentState: 'promptPlusCard',
        cardInputHelpText: action.errorMsg,
        showHelpBox: true,
      }
    case 'SELECT_OTP_METHOD':
      return {
        ...state,
        currentState: 'selectOtpMethod',
        maskedUserDetails: action.maskedUserDetails,
        showHelpBox: true,
      }
    case 'REQUEST_OTP':
      return {
        ...state,
        currentState: 'requestOtp',
        selectedOtpMethod: action.selectedMethod || state.selectedOtpMethod,
        otpInputHelpText: null,
        OtpInput: null,
      }
    case 'OTP_REQUESTED':
      return {
        ...state,
        currentState: 'awaitingOtp',
      }
    case 'SUBMIT_OTP':
      return {
        ...state,
        currentState: 'verifyingOTP',
        memberId: action.memberId,
      }
    case 'AUTHENTICATED': {
      return {
        ...state,
        currentState: 'authenticated',
      }
    }
    case 'OTP_VERIFICATION_ERROR':
      if (action.errorMsg.includes('while')) {
        return {
          ...state,
          currentState: 'promptPlusCard',
          cardInputHelpText: action.errorMsg,
          otpNumber: '',
        }
      }

      return {
        ...state,
        currentState: 'awaitingOtp',
        otpInputHelpText: action.errorMsg,
        otpNumber: '',
      }
    case 'REQUEST_OTP_ERROR':
      if (action.errorMsg.includes('while')) {
        return {
          ...state,
          currentState: 'promptPlusCard',
          cardInputHelpText: action.errorMsg,
          otpNumber: '',
        }
      }

      return {
        ...state,
        currentState: 'selectOtpMethod',
        otpInputHelpText: action.errorMsg,
        otpNumber: '',
      }
    case 'ON_CANCEL_PRESSED':
      return {
        ...state,
        currentState: 'selectOtpMethod',
        selectedOtpMethod: null,
      }
    case 'TOGGLE_CARD_INFO_MODAL':
      return { ...state, showCardInfoModal: !state.showCardInfoModal }
    case 'ON_BLUR_CARD_INPUT_FIELD':
      return {
        ...state,
        cardInputHelpText: cardNumberValidation(state.plusCardNumber),
      }
    case 'SET_OTP_NUMBER':
      return {
        ...state,
        otpNumber: action.value,
        otpInputHelpText: null,
      }
    default:
      return state
  }
}

export default reducer
